export enum TransferTypeEnum {
  ON_ROAD = 0,
  INDIVIDUAL_TOW_TRUCK = 1,
  COLLECTIVE_TOW_TRUCK = 2,
}

export const TransferTypeLabel: Record<TransferTypeEnum, string> = {
  [TransferTypeEnum.ON_ROAD]: 'On road',
  [TransferTypeEnum.INDIVIDUAL_TOW_TRUCK]: 'Individual tow-truck',
  [TransferTypeEnum.COLLECTIVE_TOW_TRUCK]: 'Collective tow-truck',
};
